import type { FontRecord } from './fonts';
import { imagePatchNeedsLayout, resolveImageItemLayout } from './imageItemLayout';
import type { ItemSizeLimits } from './itemSizing';
import { resolveTextItemLayout } from './textItemLayout';
import type { EditorItem, ImageItem, TextItem } from '../Reducers/Configurator/types';

/** Natural item size in millimeters (before user scale). */
export function getItemNaturalSizeMm(item: EditorItem): { width: number; height: number } {
  return { width: item.baseWidth, height: item.baseHeight };
}

/** Convert a source-unit measurement to millimeters at the item's current display width. */
export function sourceUnitsToMm(item: EditorItem, sourceUnits: number): number | null {
  if (!(sourceUnits > 0)) return 0;

  const sourceWidth = item.viewBoxWidth;
  if (!(sourceWidth > 0) || !(item.width > 0)) return null;

  return sourceUnits * (item.width / sourceWidth);
}

export function itemPatchNeedsLayout(item: EditorItem, patch: Partial<EditorItem>): boolean {
  if (item.type === 'text') {
    const textPatch = patch as Partial<TextItem>;
    return textPatch.content !== undefined || textPatch.fontFamily !== undefined;
  }
  return imagePatchNeedsLayout(patch as Partial<ImageItem>);
}

export async function resolveItemLayout(
  item: EditorItem,
  fonts: FontRecord[] = [],
  limits?: ItemSizeLimits,
  colorOptions: import('./itemMetrics').ColorOption[] = []
): Promise<Partial<EditorItem>> {
  if (item.type === 'text') {
    return resolveTextItemLayout(item, fonts, limits);
  }
  return resolveImageItemLayout(item, colorOptions);
}
